import { MenuItem } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const MenuItemVms = styled(MenuItem)`
  padding-right: 0;
`

export const MenuItemHepatitisAComplianceScreening = styled(MenuItem)`
  div {
    white-space: wrap;
    line-height: normal;
  }
`
